window.onload = function () {
  (function () {
    let nextElement = document.querySelector("link[rel=next]");
    const postContainer = document.querySelector(".post-feeds");
    const loadMoreButton = document.querySelector("#load-more-button");
    const valid = postContainer && loadMoreButton;

    function fetchNextPage() {
      return new Promise((resolve, reject) => {
        const xhr = new window.XMLHttpRequest();
        xhr.responseType = "document";
        xhr.addEventListener("load", (event) => resolve(event.target.response));
        xhr.open("GET", nextElement.href);
        xhr.send(null);
      });
    }

    async function loadAndAppendPosts() {
      const nextPage = await fetchNextPage();
      const postCards = nextPage.querySelectorAll(".article-single");
      postCards.forEach((card) =>
        postContainer.appendChild(document.importNode(card, true))
      );
      nextElement = nextPage.querySelector("link[rel=next]");
    }

    async function loadMorePosts() {
      if (nextElement) {
        return loadAndAppendPosts();
      }
      loadMoreButton.remove();
    }

    function init() {
      if (!nextElement) {
        loadMoreButton.remove();
      }
      if (valid) {
        loadMoreButton.addEventListener("click", () => loadMorePosts());
      }
    }

    init();
  })();
};
